import {Component, HostListener, ElementRef} from '@angular/core';

// Services
import {AppService} from '../../services/app-service';
import {CartService} from '../../../catalog/shared/services/cart-service';
import {GeneratorsService} from '../../../catalog/shared/services/generators-service';
import {NavigationService} from '../../services/navigation-service';
import {AppCatalogService} from '../../../catalog/shared/services/app-catalog-service';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:OptionsMenuCmp'));

let Ps = require('perfect-scrollbar');

@Component({
    selector: 'options-menu-cmp',
    template: require('./options-menu.cmp.html'),
    styles: [String(require('./options-menu.cmp.scss'))],
    host: {
        id: 'options-menu',
        class: 'options-menu',
        '(document:click)': 'onClick($event)'
    }
})
export class OptionsMenuCmp {

    @HostListener('window:resize', ['$event']) onResize(event) {

        // Update options menu custom scroll
        Ps.update( this._optionsMenuElement );
    }

    private _optionsMenuElement = null;

    
    constructor(
        private _elementRef: ElementRef,
        private _appService: AppService,
        private _cartService: CartService,
        private _navigationService: NavigationService,
        private _generatorsService: GeneratorsService,
        private _appCatalogService: AppCatalogService
    ) {
        // 'Construct options menu' );

        this._optionsMenuElement = _elementRef.nativeElement;
    }

    
    ngOnInit () {
        // 'Initialise options menu' );

        // Setup options menu custom scroll
        Ps.initialize( this._optionsMenuElement, {
            minScrollbarLength: 30
        });
    }

    onClick (event) {

        // Close if clicked outside of options menu except quick menu icon
        if (!this._optionsMenuElement.contains( event.target ) &&
            !event.target.classList.contains( 'options-menu' )
        ) {
            this._appService.hideOptionsMenu();
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/components/layout/options-menu.cmp.ts